/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Tour } from '../../models/tour';

export interface GetTourByNaturalId$Params {

/**
 * Natural id of a resource
 */
  natural_id: number;
}

export function getTourByNaturalId(http: HttpClient, rootUrl: string, params: GetTourByNaturalId$Params, context?: HttpContext): Observable<StrictHttpResponse<Tour>> {
  const rb = new RequestBuilder(rootUrl, getTourByNaturalId.PATH, 'get');
  if (params) {
    rb.path('natural_id', params.natural_id, {"style":"simple","explode":false});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Tour>;
    })
  );
}

getTourByNaturalId.PATH = '/api/v1/tours/natural_id/{natural_id}';
